export const navData = [
    { 
        title: 'All',
        link: '/all'
    },
    { 
        title: 'Sofas',
        link: '/sofas'
    },
    { 
        title: 'Lamps',
        link: '/lamps'
    },
    { 
        title: 'Coffee Tables',
        link: '/coffeetables'
    },
    { 
        title: 'Shelves',
        link: '/shelves'
    },
]